import React from 'react';
import './css/style.scss';
// import ReactHtmlParser from 'react-html-parser';
import { reactHtmlParser } from '../../../common/common'
function CtaCardV1({ data = {}, callback }) {
  const { title, description, button_text } = data;
  return (
    <div className="w-100 ctaCardV1Box d-flex flex-column">
      {title && (
        <h2 className="fs-2 text-black fw-semibold text-start mb-4 ctaCardTitle">{title}</h2>
      )}
      {description && (
        <p className="fs-4 text-dark fw-normal text-start">{reactHtmlParser(description)}</p>
      )}
      {button_text && (
        <h4 className="fs-16 text-primary fw-medium text-start ctaLink" onClick={callback}>
          {button_text ?? ''}
        </h4>
      )}
    </div>
  );
}

export default CtaCardV1;
